import React from 'react';
import { useRegisterTopEscapeClose } from '../../hooks/useEscapeCloseStack';

/**
 * Registers onClose for Escape while this layer is mounted (LIFO with other layers).
 */
export default function EscapeCloseLayer({ onClose, enabled = true, children }) {
  useRegisterTopEscapeClose(onClose, enabled);
  return children;
}
